import { Tour } from "../TourProvider.types";

export const TourOrganizationManageUsers: Tour = {
  name: "Managing organization members",
  pages: ["organizationPeople"],
  conditions: { isOrgAdmin: true, isPersonalSpace: false },
  description:
    "See how to invite new members to your organization and manage their access.",
  steps: [
    {
      anchorId: "invite-users-button",
      title: "Invite users",
      content:
        "Use this button to invite new users to your organization. If they are do not have an IDEAS account already they will be sent a link to sign up.",
    },
    {
      anchorId: "manage-access-menu",
      title: "Manage access",
      content:
        "Use this menu to promote users to admin (so they can also invite and manage users, as well as view usage and manage access to projects) or remove their access.",
    },
  ],
};
